@if (listing?.ready) {
<!-- listing tools -->
<product-listing-tools [listing]="listing"
                       class="block center b-b b-col-5 m-b" />
<!-- products -->
@if (listing) {
<div cy-searchProductsListing
     cy-listingProductsGrid
     class="wrap">
    <!-- empty list -->
    @if (listing.ready && !listing.getTotal()) {
    <p class="p-a center"
       cy-searchNoResults>{{'There are no results matching your selection.' | translate}}</p>
    }
    <!-- product list -->
    <div [grid]="listing.plugin.grid.gridSize()"
         [gridColumnGap]="listing.plugin.grid.getGutterCol()"
         [gridRowGap]="listing.plugin.grid.getGutterRow()"
         [gridOverflowRows]="overflowRowsQty"
         [gtmList]="context === 'search' ? {listId : 'Search results', listName : 'search' } :  category ? (category | gtmCategoryToList) : {listName: ''}"
         [gtmListListing]="asCoreListing">
        @for (model of listing.modelsWithOverflow; track model.id; let index = $index) {
        <!-- TODO: restore [gtmImpressionTrack]="{productId: model.id, position: index+1, list: context === 'search' ? 'Search results' : ''}" -->
        <product [model]="model"
                 [class.view-priority]="index < 8 || index >= visibleTilesQty"
                 [class._isOverflow]="index >= visibleTilesQty"
                 [class._isBeyondOverflow]="index >= visibleTilesQty + overflowTilesQty"
                 [gridColumn]="listing.plugin.grid.colspan(model)"
                 [gridRowSpan]="listing.plugin.grid.rowspan(model)"
                 [gtmItem]="{ position: index + 1, product : model }"
                 [listing]="listing"
                 [iCmsLink]="{type: 'product', model: model, listing: listing}"
                 style="visibility:hidden;"
                 cy-listingProduct>
        </product>
        }
    </div>
</div>
}
<!-- view more and qty viewed - no point showing below at least few elements -->
@if (listing && (listing.getTotal() > 6)) {
<!-- the slot is rendered on both sides and holds its height: hydration drops load-more until
     content init, and without the slot the content below jumped up and back down -->
<div class="m-t-8 p-t-10 center wrap _load-more-slot"
     [class._isComplete]="isLoadMoreComplete">
    <load-more *afterContentInit
               class="w-2 w-10-m w-10-s"
               [listing]="listing"
               [serverLimit]="serverLimit"></load-more>
</div>
}
}